export const DISCORD_URL = "https://discord.gg/XuXntcVkKU";
export const TWITTER_URL = "https://twitter.com/dienamx";
export const WEBSITE = "https://dienamx.com";
export const OPENSEA_URL = "https://opensea.io/collection/mytobytes";
export const HAS_LAUNCHED = true;